import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card } from "../components/ui";
import { Seo } from "../components/Seo";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!name.trim()) { toast.error("Ton prénom, s'il te plaît"); return; }
    if (!/\S+@\S+\.\S+/.test(email.trim())) { toast.error("Cet email ne semble pas valide"); return; }
    if (!message.trim()) { toast.error("Écris-nous quelques mots"); return; }
    setLoading(true);
    try {
      await api.contact(name.trim(), email.trim(), message.trim());
      setDone(true);
    } catch (e) { toast.error(e.message || "Erreur"); } finally { setLoading(false); }
  };

  const field = "w-full min-h-[52px] bg-white rounded-2xl border-2 border-km-border px-4 font-text font-semibold text-[17px] text-km-ink outline-none focus:border-km-coral";

  return (
    <PageShell>
      <Seo title="Contact" description="Une question sur la méthode, ton programme, une douleur, un souci de paiement ? Écris-nous, c'est Éric qui lit et répond sous 48 h." />
      <AppText variant="display" className="mt-4">Contact</AppText>
      <AppText variant="body" className="mt-3 text-km-ontertiary">Une question sur la méthode, ton programme, une douleur qui t'inquiète, un souci de paiement ? Écris-nous. C'est Éric qui lit, et qui répond — sous 48 h en général.</AppText>

      {done ? (
        <Card className="mt-6 flex flex-col gap-2" testID="contact-done">
          <AppText variant="subtitle">Message envoyé. Merci {name.trim()}.</AppText>
          <AppText variant="body" className="text-km-ontertiary">On te répond à {email.trim()}.</AppText>
        </Card>
      ) : (
        <Card className="mt-6 flex flex-col gap-3">
          <div>
            <AppText variant="label" className="text-km-muted mb-1">Prénom</AppText>
            <input data-testid="contact-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Léa" className={field} />
          </div>
          <div>
            <AppText variant="label" className="text-km-muted mb-1">Email</AppText>
            <input data-testid="contact-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="ton@email.fr" className={field} />
          </div>
          <div>
            <AppText variant="label" className="text-km-muted mb-1">Message</AppText>
            <textarea data-testid="contact-message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Dis-nous tout" rows={5}
              className="w-full bg-white rounded-2xl border-2 border-km-border px-4 py-3 font-text font-semibold text-[17px] text-km-ink outline-none focus:border-km-coral resize-none" />
          </div>
          <Button title="Envoyer" onClick={submit} loading={loading} testID="contact-submit" />
          <AppText variant="caption" className="text-km-muted">Tes données servent uniquement à te répondre. Aucune newsletter sans ton accord.</AppText>
        </Card>
      )}
    </PageShell>
  );
}
